import React from 'react';
import { Predictions } from '../../../api/cafAutomation';
import { formatIsoDay } from '../format';
import { WORKLIST_NAMES } from './steps';

const deadlineWord = (kind: string): string => (kind === 'fos' ? 'FOS' : 'objection');

/** What a Watching decision would have recorded. Nothing here happened. */
export const PredictedSteps: React.FC<{ predictions?: Predictions | null }> = ({ predictions }) => {
  if (!predictions) return null;
  const lines = predictions.key_dates.map((item) => (item.date
    ? `Would record the ${deadlineWord(item.kind)} deadline: ${formatIsoDay(item.date)}${item.estimated ? ' (estimated from the date we received it)' : ''}`
    : `Couldn't work out the ${deadlineWord(item.kind)} deadline, so it would stop for a person`));
  if (predictions.worklist) lines.push(`Would put it on the list: ${WORKLIST_NAMES[predictions.worklist.worklist] ?? 'Not sure'}`);
  if (!lines.length) return null;
  return <ul className="cur-hint" aria-label="What it would record">{lines.map((line, index) => <li key={`${index}-${line}`}>{line}</li>)}</ul>;
};
